import {useAppContext} from "../../../contexts/AppContext";
import {SettlementsTree} from "./SettlementsTree";
import {CropsManager} from "./CropsManager";

export const AdminNomenclature = () => {
    const {years} = useAppContext();
    const sortedYears = [...years].sort((a, b) => a.year - b.year);

    return (
        <div>
            <h3 className="mb-3">Номенклатури</h3>

            <section className="mb-4">
                <h5>Активни землища</h5>
                <p className="text-muted small mb-2">
                    Включи или изключи области, общини или отделни землища. Само активните
                    се показват при работа (списъци, търсене). Работиш ли в ново землище —
                    просто го включи тук.
                </p>
                <SettlementsTree/>
            </section>

            <section className="mb-4">
                <h5>Култури</h5>
                <p className="text-muted small mb-2">
                    Падащият списък при изчертаване. Преименуването сменя само
                    номенклатурата (историческите изчертавания не се променят).
                </p>
                <CropsManager/>
            </section>

            <section>
                <h5>Стопански години</h5>
                <p className="text-muted small mb-2">
                    Годините се появяват автоматично при качване на данни за тях
                    (само за преглед).
                </p>
                <div className="d-flex flex-wrap gap-1">
                    {sortedYears.length === 0
                        ? <span className="text-muted">Няма данни.</span>
                        : sortedYears.map(y => (
                            <span key={y.year} className="badge bg-body-secondary text-body border">{y.year}</span>
                        ))}
                </div>
            </section>
        </div>
    );
};
